import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Folder } from "lucide-react";
 * // Use <Folder /> instead
 */
export const CatalogIcon = createSVGWrapper(
  <>
    <path
      d="M2.99921 4.99997C2.99921 4.44768 3.44692 3.99997 3.99921 3.99997H8.49921L10.9992 5.99997H17.9992C18.5515 5.99997 18.9992 6.44768 18.9992 6.99997V8.99997H6.69138C5.44084 8.99997 4.32148 9.77569 3.88239 10.9466L2.99921 13.3017V4.99997Z"
      fill="currentColor"
    />
    <path
      d="M4.44072 19H18.3047C18.7216 19 19.0947 18.7415 19.2411 18.3512L21.4911 12.3512C21.7362 11.6974 21.2529 11 20.5547 11H6.69073C6.27388 11 5.90076 11.2586 5.7544 11.6489L3.50439 17.6489C3.25924 18.3027 3.74252 19 4.44072 19Z"
      fill="currentColor"
    />
  </>
);
